import { create } from "zustand";
import { persist } from "zustand/middleware";

// Define trip filter type
export interface TripFilter {
  showAll: boolean;
  visibleTripIds: string[];
  hiddenTripIds: string[];
}

interface ShortcutsState {
  // Visibility toggles
  showPickups: boolean;
  showDeliveries: boolean;
  showDepots: boolean;
  showOperators: boolean;

  // Trip filtering
  tripFilter: TripFilter;

  // Selection mode
  isSelectingMode: boolean;

  // Actions
  setShowPickups: (show: boolean) => void;
  setShowDeliveries: (show: boolean) => void;
  setShowDepots: (show: boolean) => void;
  setShowOperators: (show: boolean) => void;
  setTripFilter: (filter: TripFilter) => void;
  setIsSelectingMode: (isSelecting: boolean) => void;
  toggleSelectingMode: () => void;

  // Trip visibility helpers
  toggleAllTrips: () => void;
}

export const useShortcutsStore = create<ShortcutsState>()(
  persist(
    (set) => ({
      // Default values
      showPickups: true,
      showDeliveries: true,
      showDepots: true,
      showOperators: true,
      isSelectingMode: false,

      tripFilter: {
        showAll: true,
        visibleTripIds: [],
        hiddenTripIds: [],
      },

      // Setters
      setShowPickups: (show) => set({ showPickups: show }),
      setShowDeliveries: (show) => set({ showDeliveries: show }),
      setShowDepots: (show) => set({ showDepots: show }),
      setShowOperators: (show) => set({ showOperators: show }),
      setTripFilter: (filter) => set({ tripFilter: filter }),
      setIsSelectingMode: (isSelecting) =>
        set({ isSelectingMode: isSelecting }),

      // Toggle helpers
      toggleSelectingMode: () =>
        set((state) => ({ isSelectingMode: !state.isSelectingMode })),

      // Trip filter helpers
      toggleAllTrips: () =>
        set((state) => ({
          tripFilter: {
            showAll: !state.tripFilter.showAll,
            visibleTripIds: [],
            hiddenTripIds: [],
          },
        })),
    }),
    {
      name: "shortcuts-storage", // unique name for localStorage key
      partialize: (state) => ({
        // Only persist these fields (ignore functions)
        showPickups: state.showPickups,
        showDeliveries: state.showDeliveries,
        showDepots: state.showDepots,
        showOperators: state.showOperators,
        tripFilter: state.tripFilter,
        isSelectingMode: state.isSelectingMode,
      }),
    }
  )
);
